import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../api";
import { Download } from "lucide-react";
import useNoIndex from "../useNoIndex";

export default function ShareView() {
  useNoIndex();
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API_BASE}/share/${token}`);
        setData(r.data);
      } catch (e) {
        setErr(e.response?.data?.detail || "Link unavailable.");
      }
    })();
  }, [token]);

  async function download(d) {
    const r = await axios.get(`${API_BASE}/share/${token}/document/${d.document_id}`);
    const link = document.createElement("a");
    link.href = `data:${r.data.mime_type};base64,${r.data.file_b64}`;
    link.download = r.data.file_name || d.name;
    link.click();
  }

  if (err) {
    return (
      <div className="container-cd py-24" data-testid="share-error">
        <div className="overline" style={{ color: "var(--red)" }}>LINK ERROR</div>
        <h1 className="font-display text-5xl mt-4">{err}</h1>
      </div>
    );
  }
  if (!data) return <div className="container-cd py-20 overline">LOADING…</div>;

  return (
    <div className="container-cd py-16" data-testid="share-view-page">
      <div className="overline">CONFIDENTIAL · SHARE · EXPIRES {new Date(data.share.expires_at).toLocaleDateString()}</div>
      <h1 className="font-display text-5xl md:text-6xl mt-4 leading-[0.9]">
        {data.manufacturer.company_name}
      </h1>
      <div className="mt-2 font-mono text-xs" style={{ color: "var(--ink-2)" }}>
        {data.manufacturer.city} · DOCUMENTS · {data.documents.length}
      </div>
      {data.share.note ? (
        <div className="cd-card p-6 mt-8" style={{ borderColor: "var(--orange)" }}>
          <div className="overline">NOTE</div>
          <p className="mt-2">{data.share.note}</p>
        </div>
      ) : null}
      <div className="mt-10 cd-card p-0 overflow-x-auto">
        <table className="cd-table">
          <thead>
            <tr>
              <th>Doc</th>
              <th>Category</th>
              <th>Issued</th>
              <th>Expires</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.documents.map((d) => (
              <tr key={d.document_id}>
                <td>
                  <div className="font-semibold">{d.name}</div>
                  {d.notes ? <div className="text-xs" style={{ color: "var(--ink-2)" }}>{d.notes}</div> : null}
                </td>
                <td><span className="cd-chip">{d.category}</span></td>
                <td className="font-mono text-xs">{d.issued_at || "—"}</td>
                <td className="font-mono text-xs">{d.expires_at || "—"}</td>
                <td className="text-right">
                  {d.has_file ? (
                    <button onClick={() => download(d)} className="btn btn-ghost btn-sm" data-testid={`share-download-${d.document_id}`}>
                      <Download size={12} /> Download
                    </button>
                  ) : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
